import { Home, Phone, LogOut, Sun, Moon, User, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Link, useNavigate } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
import { useState, useEffect } from 'react';
import { useAuth } from '@/components/AuthProvider';
import obrimLogo from '@/assets/obrim-logo-transparent.png';
export const DashboardTopbar = () => {
  const navigate = useNavigate();
  const {
    toast
  } = useToast();
  const [isDark, setIsDark] = useState(false);
  const {
    user,
    signOut
  } = useAuth();
  useEffect(() => {
    // Verificar tema atual
    const isDarkMode = document.documentElement.classList.contains('dark');
    setIsDark(isDarkMode);
  }, []);
  const toggleTheme = () => {
    const newTheme = !isDark;
    setIsDark(newTheme);

    // Aplicar transição suave com animação
    document.body.classList.add('animate-theme-transition');
    if (newTheme) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }

    // Remover classe de transição após animação
    setTimeout(() => {
      document.body.classList.remove('animate-theme-transition');
    }, 300);

    // Feedback visual com toast
    toast({
      title: `Tema ${newTheme ? 'escuro' : 'claro'} ativado`,
      description: `Interface alterada para modo ${newTheme ? 'escuro' : 'claro'}`,
      duration: 2000
    });
  };
  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/');
      toast({
        title: "Você saiu com sucesso",
        description: "Até logo!"
      });
    } catch (error) {
      toast({
        title: "Erro no logout",
        description: "Tente novamente.",
        variant: "destructive"
      });
    }
  };
  const getUserName = () => {
    if (user?.user_metadata?.full_name) {
      return user.user_metadata.full_name;
    }
    return user?.email?.split('@')[0] || 'Usuário';
  };
  const getInitials = (name: string) => {
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };
  return <header className="fixed top-0 left-0 right-0 z-50 h-16 glass-effect border-b border-border/50 shadow-elegant animate-slide-down">
      <div className="w-full max-w-none px-6 h-full flex items-center justify-between">
        {/* Logo Obrim */}
        <Link to="/" className="flex items-center hover:opacity-80 transition-all duration-300" onClick={() => {
        console.log('DashboardTopbar Logo - Setting intentionalNavigation flag');
        // Set flag to prevent auto-redirect when clicking logo
        localStorage.setItem('intentionalNavigation', 'true');
      }}>
          <img alt="Obrim - Gestão de Obras" src="/lovable-uploads/7a593f0f-94f7-4cb2-9add-cd33e793105b.png" className="h-12 object-contain" />
        </Link>

        {/* Navigation e Controles */}
        <div className="flex items-center space-x-4">
          {/* Botões de Navegação */}
          <div className="hidden md:flex items-center space-x-2">
            <Button variant="ghost" size="sm" className="hover:bg-muted transition-all duration-300 text-muted-foreground hover:text-foreground animate-micro-scale hover:shadow-sm" onClick={() => navigate('/contato')}>
              <Phone className="h-4 w-4 animate-micro-rotate" />
              <span className="ml-2">Contato</span>
            </Button>
          </div>

          {/* Botão Novo Projeto */}
          <Button size="sm" className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-4 py-2 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105" onClick={() => navigate('/projects?create=true')}>
            <Plus className="h-4 w-4 mr-2" />
            Novo Projeto
          </Button>

          <div className="w-px h-6 bg-border/50" />
          
          {/* Toggle de Tema */}
          <Button variant="ghost" size="sm" onClick={toggleTheme} className="hover:bg-muted transition-all duration-300 animate-micro-scale hover:shadow-sm p-2 rounded-lg">
            {isDark ? <Sun className="h-4 w-4 text-muted-foreground animate-micro-rotate transition-transform" /> : <Moon className="h-4 w-4 text-muted-foreground animate-micro-rotate transition-transform" />}
          </Button>
          
          {/* Avatar do Usuário */}
          <div className="flex items-center space-x-3 animate-micro-scale hover:scale-105 transition-transform">
            <div className="hidden sm:block text-right">
              <p className="text-sm font-medium text-foreground">{getUserName()}</p>
              <p className="text-xs text-muted-foreground">{user?.email}</p>
            </div>
            <Avatar className="h-8 w-8 hover:shadow-lg transition-all duration-300 cursor-pointer hover:scale-110">
              <AvatarFallback className="bg-primary text-primary-foreground text-xs font-semibold">
                {getInitials(getUserName())}
              </AvatarFallback>
            </Avatar>
          </div>
          
          <div className="w-px h-6 bg-border/50" />
          
          {/* Botão de Logout */}
          <Button variant="ghost" size="sm" onClick={handleLogout} className="hover:bg-destructive/10 hover:text-destructive transition-all duration-300 animate-micro-scale hover:shadow-sm">
            <LogOut className="h-4 w-4 animate-micro-rotate" />
            <span className="hidden sm:inline ml-2">Sair</span>
          </Button>
        </div>
      </div>
    </header>;
};